const tmfDomain = 'https://www.takemefishing.org/';

export default function getBaseUrl() {
  const locale = window.TMF_CONFIG?.locale ?? 'en';

  return locale === 'es' ? `${tmfDomain}es/` : tmfDomain;
}
